import { criarFinalizador } from '@/uteis/action/devolver/finalizador'

export const criarDevolucao = (processo, motivo, dadosSessao, destinatario) => {
  var tramite = {
    processos: [{
      numero: processo.data.processo,
      motivo: motivo
    }],
    executor: criarFinalizador(dadosSessao, true),
    origem: criarFinalizador(dadosSessao, false),
    destino: destinatario,
    atributos: {
      motivo: motivo,
      assunto: processo.data.atributos.assunto,
      devolvido: true
    }
  }

  return tramite
}
